import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const usePreparedOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.ready_to_pickup);

  return useApiMutation({
    url: `/orders/${orderId}/ready-to-pickup`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar status do pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido em pronto aguardando cliente!',
    onSuccess,
  });
};

export default usePreparedOrder;
